export function formatStagePlannedDate (value) {
  if (!value) return '—'
  try {
    const date = typeof value === 'string' ? new Date(value) : value
    if (Number.isNaN(date.getTime())) return '—'
    return date.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' })
  } catch {
    return '—'
  }
}

function isDoneStageStatus (status) {
  const value = String(status || '').trim().toLowerCase()
  return value.includes('сдан')
    || value.includes('заверш')
    || value.includes('закры')
    || value.includes('заакт')
}

export function isObjectStagePlannedDateOverdue (stage) {
  if (!stage || stage.fact_date || stage.completion_date) return false
  if (isDoneStageStatus(stage.status)) return false
  const planned = stage.planned_date
  if (!planned) return false

  const date = new Date(planned)
  if (Number.isNaN(date.getTime())) return false

  const today = new Date()
  today.setHours(0, 0, 0, 0)
  date.setHours(0, 0, 0, 0)
  return date < today
}
